import { motion, AnimatePresence } from 'framer-motion';
import { giveConsent, denyConsent } from '../lib/consent';
import { initAnalytics } from '../lib/analytics';

export default function ConsentBanner({ visible, onDecide }) {
  const handleAccept = () => {
    giveConsent();
    initAnalytics();
    onDecide();
  };

  const handleDecline = () => {
    denyConsent();
    onDecide();
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          style={{
            position: 'fixed',
            bottom: '20px',
            left: '16px',
            right: '16px',
            width: 'auto',
            maxWidth: '560px',
            margin: '0 auto',
            zIndex: 1000,
            background: '#0F1923',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: '16px',
            padding: '14px 16px',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            boxShadow: '0 4px 24px rgba(0,0,0,0.4)',
          }}
        >
          {/* Top row: icon + text */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
            {/* Icon */}
            <div
              style={{
                flexShrink: 0,
                width: '32px',
                height: '32px',
                borderRadius: '9px',
                background: 'rgba(45,212,191,0.1)',
                border: '1px solid rgba(45,212,191,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '15px',
                marginTop: '1px',
              }}
            >
              🍪
            </div>

            {/* Text */}
            <p style={{
              flex: 1,
              fontSize: '13px',
              color: '#94A3B8',
              lineHeight: 1.55,
              margin: 0,
            }}>
              We use anonymous analytics to improve IngrediScan. No ads, no selling data.{' '}
              <a
                href="https://www.ingrediscan.in/privacy"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#2DD4BF', textDecoration: 'none' }}
              >
                Privacy Policy ↗
              </a>
              {' · '}
              <a
                href="https://www.ingrediscan.in/terms"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#2DD4BF', textDecoration: 'none' }}
              >
                Terms ↗
              </a>
            </p>
          </div>

          {/* Bottom row: buttons right-aligned */}
          <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
            <motion.button
              onClick={handleDecline}
              whileHover={{ background: 'rgba(255,255,255,0.07)' }}
              whileTap={{ scale: 0.97 }}
              style={{
                padding: '9px 18px',
                borderRadius: '10px',
                border: '1px solid rgba(255,255,255,0.1)',
                background: 'rgba(255,255,255,0.04)',
                color: '#64748B',
                fontSize: '13px',
                fontWeight: 500,
                cursor: 'pointer',
                fontFamily: "'DM Sans', system-ui, sans-serif",
              }}
            >
              Decline
            </motion.button>
            <motion.button
              onClick={handleAccept}
              whileHover={{ background: '#5EEAD4' }}
              whileTap={{ scale: 0.97 }}
              style={{
                padding: '9px 20px',
                borderRadius: '10px',
                border: 'none',
                background: '#2DD4BF',
                color: '#000',
                fontSize: '13px',
                fontWeight: 700,
                cursor: 'pointer',
                fontFamily: "'DM Sans', system-ui, sans-serif",
              }}
            >
              Accept
            </motion.button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
